import { APIResultList, API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";

type Args = {
  assetIds: string[];
};

const [useDeleteAssets, deleteAssets] = createAsyncAction(
  "assets/delete",
  async ({ assetIds }: Args) => {
    const data = {
      assets: assetIds.map(uuid => ({ uuid, status: "deleted" })),
    };

    // The result strings can be either item or asset
    // The API returns deleted items along with the deleted assets
    return await API.call<APIResultList<"assets", string>>({
      endpoint: "sync/assets",
      method: "POST",
      data,
    });
  }
);

export default useDeleteAssets;
export { deleteAssets };
